export const GET_AVAILABLE_EDOK_MODULES_REQUEST = 'GET_AVAILABLE_EDOK_MODULES_REQUEST';

export const getAvailableEdokModulesRequest = () => ({
    type: GET_AVAILABLE_EDOK_MODULES_REQUEST,
});
